/// <reference path="waitList.module.ts" />
/// <reference path="../../../../typings/index.d.ts" />

module Meevo.Plugins.WaitList {

    class WaitListModalController {
        static $inject = ["employee"];
        public results: any;
        constructor(private employee: any) {
            this.getResults();

        }

        getResults():void  {
            this.results = this.employee;
        }

    }



    angular.module("meevo.plugins.waitList")
        .controller("meevo.plugins.schedules.WaitListModalController", WaitListModalController);
}
